/**
 * Report Service - 报表数据服务
 * 页面组件只调用此 Service 层,不直接调用 API
 */

import { config } from '../../config';
import * as reportMock from '../../mocks/report';
import httpClient from '../httpClient';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';

/**
 * 查询 SLA 履约报表
 */
export async function pageSLAFulfillment(params) {
  if (config.mock) {
    return reportMock.mockPageSLAFulfillment(params);
  }

  return httpClient.post(API_ENDPOINTS.REPORT.SLA_FULFILLMENT_PAGE, params);
}

/**
 * 导出 SLA 报表
 */
export async function exportSLAFulfillment(params) {
  return httpClient.post(API_ENDPOINTS.REPORT.SLA_FULFILLMENT_EXPORT, params);
}

/**
 * 查询 SLA 报表渠道选项
 */
export async function getSlaChannelOptions() {
  return httpClient.post(API_ENDPOINTS.REPORT.SLA_CHANNEL_OPTION, {});
}

/**
 * 查询支付发票报表
 */
export async function pagePaymentInvoice(params) {
  if (config.mock) {
    return reportMock.mockPagePaymentInvoice(params);
  }

  return httpClient.post(API_ENDPOINTS.REPORT.PAYMENT_INVOICE_PAGE, params);
}

/**
 * 查询 COD 对账报表（订单级明细）
 */
export async function pageCodReconciliation(params) {
  return httpClient.post(API_ENDPOINTS.REPORT.COD_RECONCILIATION_PAGE, params);
}

/**
 * 导出 COD 对账报表
 */
export async function exportCodReconciliation(params) {
  return httpClient.post(API_ENDPOINTS.REPORT.COD_RECONCILIATION_EXPORT, params);
}

/**
 * 查询 COD 对账报表骑手选项
 */
export async function getCodRiderOptions() {
  return httpClient.post(API_ENDPOINTS.REPORT.COD_RECONCILIATION_RIDER_OPTION, {});
}

/**
 * 查询 COD 对账报表 POS 机号选项
 */
export async function getCodPosOptions() {
  return httpClient.post(API_ENDPOINTS.REPORT.COD_RECONCILIATION_POS_OPTION, {});
}
